export default "__VITE_ASSET__BWmCve3D__"